import { HttpContextToken } from "@angular/common/http";
import { signal } from "@angular/core";

/**
 * Background requests (polling, e.g. Messages; presigned image URLs) that must not flash
 * the full-screen loader: pass `{ silent: true }` to RequestService.
 */
export const SILENT_REQUEST = new HttpContextToken<boolean>(() => false);

/**
 * A background poll (`{ background: true }`, which is also silent): when it comes back
 * "Unauthorized" it does not hard-redirect to /login (a poll shouldn't yank the page away
 * mid-read); it sets `silentSessionExpired` and the pollers stop. User-initiated requests
 * (silent or not) still redirect as before.
 */
export const BACKGROUND_REQUEST = new HttpContextToken<boolean>(() => false);

/**
 * Set when a background poll found the session expired; pollers check it and stop.
 * Cleared again by the interceptor on the next successful user-initiated request.
 */
export const silentSessionExpired = signal(false);
